var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.9375 9C0.9375 4.5472 4.5472 0.9375 9 0.9375C13.4528 0.9375 17.0625 4.5472 17.0625 9C17.0625 13.4528 13.4528 17.0625 9 17.0625C4.5472 17.0625 0.9375 13.4528 0.9375 9ZM9 2.0625C5.16852 2.0625 2.0625 5.16852 2.0625 9C2.0625 12.8315 5.16852 15.9375 9 15.9375C12.8315 15.9375 15.9375 12.8315 15.9375 9C15.9375 5.16852 12.8315 2.0625 9 2.0625Z",
    fill: "#E45B3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5193 6.48116C11.739 6.70083 11.739 7.05698 11.5193 7.27665L7.27665 11.5193C7.05698 11.739 6.70083 11.739 6.48116 11.5193C6.26149 11.2996 6.26149 10.9435 6.48116 10.7238L10.7238 6.48116C10.9435 6.26149 11.2996 6.26149 11.5193 6.48116Z",
    fill: "#E45B3D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.48116 6.48116C6.70083 6.26149 7.05698 6.26149 7.27665 6.48116L11.5193 10.7238C11.739 10.9435 11.739 11.2996 11.5193 11.5193C11.2996 11.739 10.9435 11.739 10.7238 11.5193L6.48116 7.27665C6.26149 7.05698 6.26149 6.70083 6.48116 6.48116Z",
    fill: "#E45B3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallClose);
export default __webpack_public_path__ + "static/media/small-close.9aa401654b5c412e5205bf268a9e902d.svg";
export { ForwardRef as ReactComponent };